<style lang="scss" src='./Messages.scss' scoped></style>
<template src="./Messages.html"></template>

<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';
import TaskDetails from '@/views/task/details/TaskDetails.vue';
export default {
  name: 'Messages',
  components: {
    UserAvatar,
    TaskDetails,
  },
  data() {
    return ({
      refreshDataInterval: null,
    });
  },
  computed: {
    ...mapState('Messages', ['showMessages', 'count', 'messagesList', 'taskInforamtion']),
  },

  methods: {
    ...mapMutations('Messages', ['changeContainer', 'setShowNews']),
    ...mapActions('Messages', ['apiGetCountMessages', 'apiUpdateCountMessages', 'apiGetMessages', 'apiGetTask']),
    async getTask(message) {
      await this.apiGetTask(message.task_id);
      this.$refs.taskDetails.openModal(this.taskInforamtion);
      this.changeContainer(false);
      this.apiUpdateCountMessages()
    },

    startIntervalToRefreshData() {
      this.refreshDataInterval = window.setInterval(() => {
        this.apiGetCountMessages();
        this.apiGetMessages();
      }, process.env.VUE_APP_REFRESH_DATA_TIME_MS);
    },

  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.apiGetMessages();
    this.apiGetCountMessages();
    this.startIntervalToRefreshData();
  },

  beforeDestroy() {
    window.clearInterval(this.refreshDataInterval);
  },

  };

</script>
